import { render, staticRenderFns } from "./NotificationContainer.vue?vue&type=template&id=2e6c337b&scoped=true&lang=pug&"
import script from "./NotificationContainer.vue?vue&type=script&lang=js&"
export * from "./NotificationContainer.vue?vue&type=script&lang=js&"
import style0 from "./NotificationContainer.vue?vue&type=style&index=0&id=2e6c337b&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6c337b",
  null
  
)

export default component.exports